import { Delete, Done, Edit } from "@mui/icons-material";
import { Box, IconButton, MenuItem, Select, Tooltip } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { tableConfig } from "./config/tableConfig";
import TitleContainer from "./utilsTable/titleWithFetchData";

const ArtInProviderTable = ({
  data,
  handleOpenEdit,
  handleDelete,
  handleOpenConfirm,
}) => {
  const columns = [
    {
      header: "Nombre",
      accessorKey: "nombre",
    },
    {
      header: "Identificador",
      accessorKey: "idPrestadorArt",
    },
    {
      header: "Estado",
      accessorKey: "adherida",
      Cell: ({ row }) => {
        const value = row.original.adherida;
        switch (value) {
          case 0:
            return "Adherida";
          case 1:
            return "No Adherida";
          case 2:
            return "Pendiente";
          default:
            return "";
        }
      },
      Filter: ({ column }) => (
        <Select
          fullWidth
          sx={{ minWidth: 150, maxHeight: 40 }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value || undefined)}
          displayEmpty>
          <MenuItem value="">Todos</MenuItem>
          <MenuItem value="Adherida">Adherida</MenuItem>
          <MenuItem value="No Adherida">No Adherida</MenuItem>
          <MenuItem value="Pendiente">Pendiente</MenuItem>
        </Select>
      ),
      filterFn: (row, columnId, filterValue) => {
        const cellValue =
          row.getValue(columnId) === 0 ? "Adherida" : "Pendiente";
        return !filterValue || cellValue === filterValue;
      },
      enableColumnActions: false,
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      enableColumnFilter: false,
      enableColumnActions: false,
      Cell: ({ row }) => (
        <>
          {row.original.adherida !== 0 && (
            <Tooltip title="Confirmar Adhesión">
              <IconButton
                color="inherit"
                onClick={() => handleOpenConfirm(row.original)}>
                <Done />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Editar Adhesión">
            <IconButton
              color="inherit"
              onClick={() => handleOpenEdit(row.original)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar Adhesión">
            <IconButton
              color="inherit"
              onClick={() => handleDelete(row.original)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <div>
      <MaterialReactTable
        {...tableConfig}
        columns={columns}
        data={data}
        renderTopToolbarCustomActions={() => (
          <Box m={0.5} display="flex">
            <TitleContainer title="Adhesiones con Arts" />
          </Box>
        )}
      />
    </div>
  );
};
export default ArtInProviderTable;
